import React, { useState, useEffect, useRef } from "react";
import Items from '../items/Items';
import { tipoArticulos} from "../../data/catalogos"


const descriptionEditorOptions = { height: 100 };


const Accesorios = props => {
    return (
    <Items title="Accesorios" typeId={tipoArticulos.Accesorios} ></Items>
);
}

export default Accesorios;